import { useIonToast } from '@ionic/react';
import { useEffect, useState } from 'react';
import { useGeoLocation } from 'services/GeoLocation';
import { ST } from 'types';
import { makeErrorToast } from '../../util';
import { t } from 'i18next';
import { MESSAGE_ALIVE_MS, MESSAGE_POSITION } from 'util/constants';

const useLocation = () => {
  const [toast, dismiss] = useIonToast();
  const [present] = useIonToast();
  const locationService = useGeoLocation();
  const [location, setLocation] = useState<ST.Location | null>(null);

  useEffect(() => {
    if (location !== null) {
      return;
    }
    locationService.getCurrentLocation()
      .then((loc: ST.Location) => {
        setLocation(loc);
        locationService.getAddressFromLocation(loc).then((addr: string) => {
          loc!.name = addr;
          setLocation(loc);
        });
      })
      .catch(() => {
        var errorMessage = t('LOCATION_PERMISSION_DENIED');
        present({
          message: errorMessage,
          duration: MESSAGE_ALIVE_MS,
          color: 'warning',
          position: MESSAGE_POSITION,
        });
      });
  }, [locationService, dismiss, toast, location]);

  const resetLocation = () => {
    setLocation(null);
  };

  return { location, resetLocation };
};

export default useLocation;
